import LcView from "lib/shared/view";
import EssayPromptsChannel from "channels/essay_prompts_channel";

export default LcView.create({
  ready() {
    $("body").on("submit", "form#prototype-form", function () {
      $.ajax({
        beforeSend() {
          $("#result-indicator").html("Submitted. Please wait.");
          $("#guide-portion-area").html("");
          $("#response-area").html("");
          $("#prompt-area").html("");
        },
        data: $(this).serialize(),
        dataType: "json",
        error(data, status, _settings) {
          if (status === "timeout") {
            $("#result-indicator").html("Timed out.");
          } else {
            $("#result-indicator").html(data.responseText);
          }
        },
        success(data, _status, _settings) {
          const finalPrompt = data.final_prompt;
          const chunks = data.resource_materials;

          $("#prompt-area").text(finalPrompt);
          $("#guide-portion-area").text(chunks);
        },
        type: "POST",
        url: $(this).attr("action")
      });
      return false;
    });
    EssayPromptsChannel();
  }
});
